export default function initFilterPanel() {
	const win = jQuery(window);
	const fixedPanel = jQuery('.sticky-filter-btn');
	const activeClass = 'active';

	jQuery('.filter-panel').each(function() {
		const holder = jQuery(this);
		let scrollTop = win.scrollTop();
		let holderOffset = holder.offset().top;
		let holderHeight = holder.outerHeight();

		function scrollHandler() {
			scrollTop = win.scrollTop();
			holderOffset = holder.offset().top;
			holderHeight = holder.outerHeight();

			if (scrollTop > holderHeight + holderOffset) {
				fixedPanel.addClass(activeClass);
			} else {
				fixedPanel.removeClass(activeClass);
			}
		}

		win.on('load resize orientationchange scroll', scrollHandler);
	});
}